export default "__VITE_ASSET__8J8uyoYq__"